import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Add } from "@gaming/xds-react-js-icons";

import { useStrings } from "../../../localization/localizationHelpers";
import * as styles from "./AddIcon.module.css";

export const AddIcon = () => {
  const [addIcon] = useStrings("addIcon");
  return <Icon title={addIcon} className={styles.addIcon} icon={Add} iconSize={IconSize.Custom} />;
};
